import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import api from './config';

const initialState = {
  entries: [],
  loading: false,
  errors: []
};

// GET /activity-log — réservé SUPER_ADMIN côté backend (voir activity-log.controller.ts).
export const fetchActivityLog = createAsyncThunk(
  'activityLog/fetchActivityLog',
  async (params = {}, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get('/activity-log', { params });
      return response.data;
    } catch (error) {
      if (!error.response) throw error;
      if (error.response.status === 401) dispatch(logout());
      return rejectWithValue({ message: error.response.data?.message });
    }
  }
);

const activityLogSlice = createSlice({
  name: 'activityLog',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityLog.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActivityLog.fulfilled, (state, { payload }) => {
        state.entries = payload || [];
        state.loading = false;
      })
      .addCase(fetchActivityLog.rejected, (state, { payload }) => {
        state.entries = [];
        state.errors = payload?.message ? [payload.message] : ['error'];
        state.loading = false;
      });
  }
});

export default activityLogSlice.reducer;
